// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfh_a bhc_vc bhc_rm bhc_wf"};